/**
 * AuthShell — centered logo + tagline + card wrapper for the auth screens
 * (login / signup / verify-email). Expects a flex-column page parent so the
 * `flex-1` centering has height to work with.
 */
import type { ReactNode } from 'react';
import { BrandMark } from '@/components/patterns/brand-mark';

export interface AuthShellProps {
  children: ReactNode;
}

export function AuthShell({ children }: AuthShellProps) {
  return (
    <div className="flex flex-1 items-center justify-center px-6 py-12">
      <div className="w-[400px]">
        <div className="mb-7 flex flex-col items-center gap-2 text-center">
          <div className="flex items-center gap-2">
            <BrandMark size={22} />
            <span className="text-[22px] font-bold tracking-[-0.02em]">Brain</span>
          </div>
          <p className="text-[14.5px] text-faint">Your group chat, made searchable.</p>
        </div>
        <div className="rounded-2xl border border-[#e9e9eb] bg-card p-8">{children}</div>
      </div>
    </div>
  );
}
